import { render } from "./PDetails2.vue?vue&type=template&id=3c021696&scoped=true"
import script from "./PDetails2.vue?vue&type=script&lang=js"
export * from "./PDetails2.vue?vue&type=script&lang=js"

import "./PDetails2.vue?vue&type=style&index=0&id=3c021696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c021696"]])

export default __exports__